<template>
  <main>
    <div class="regist-choose-name" v-if="!next3">
      <div v-if="!next3" class="backgroundImage"></div>
      <template v-if="!next2">
        <img class="avatar" v-if="registInfo.orgInfo.unitAttr == '8'" src="@/assets/image/icon1.png" alt="" />
        <img class="avatar" v-else src="@/assets/image/icon2.png" alt="" />
        <h3 class="title current">{{ registInfo.orgInfo.displayName }}</h3>
        <div class="new-input">
          <input type="text" placeholder="姓名" v-model.trim="username" />
        </div>
        <div class="submit" :class="{active: active1}" @click="onNext1">下一步</div>
      </template>

      <template v-if="next2">
        <h3 class="title">设置密码</h3>
        <div class="new-input">
          <input type="password" placeholder="输入至少6位新密码" v-model.trim="password" />
        </div>
        <div class="new-input">
          <input type="password" placeholder="输入至少6位新密码" v-model.trim="newPassword" />
        </div>
        <div class="submit" :class="{active: active2}" @click="onNext2">下一步</div>
      </template>
    </div>

    <section class="confirm" v-if="next3">
      <div class="tips">请确认您的姓名和机构真实，否则将会影响到学时证书的领取</div>
      <div class="content">
        <ul class="info-list">
          <li class="info-item">
            <div class="name">
              <span>姓</span>
              <span>名</span>
            </div>
            <div class="info-detail">{{ username }}</div>
          </li>
          <li class="info-item">
            <div class="name">
              <span>手</span>
              <span>机</span>
              <span>号</span>
            </div>
            <div class="info-detail">{{ registInfo.phone }}</div>
          </li>
          <li class="info-item">
            <div class="name">
              <span>机</span>
              <span>构</span>
            </div>
            <div class="info-detail">{{ registInfo.orgInfo.displayName }}</div>
          </li>
        </ul>

        <div class="btn" @click="onSubmit">提交注册</div>
        <div class="tips2" @click="onReset">信息有误，重新填写</div>
      </div>
    </section>
  </main>
</template>

<script>
import {authSignup} from '@/api'
export default {
  data() {
    return {
      next2: false,
      next3: false,
      active1: false,
      active2: false,

      username: '',
      password: '',
      newPassword: '',
      registInfo: {
        orgInfo: '',
        verifyId: '',
        phone: ''
      },
      params: null
    }
  },
  watch: {
    username(newV) {
      this.handleActiveVerifyActive1()
    },
    password(newV) {
      this.handleActiveVerifyActive2()
    },
    newPassword(newV) {
      this.handleActiveVerifyActive2()
    }
  },
  created() {
    this.registInfo = JSON.parse(localStorage.getItem('registInfo'))
  },
  methods: {
    handleActiveVerifyActive1() {
      if (this.username) {
        this.active1 = true
      } else {
        this.active1 = false
      }
    },
    handleActiveVerifyActive2() {
      if (this.password && this.newPassword) {
        this.active2 = true
      } else {
        this.active2 = false
      }
    },
    onNext1() {
      if (!this.active1) {
        return false
      }
      this.next2 = true
    },
    onNext2() {
      if (!this.active2) {
        return false
      }
      if (!this.username) {
        return this.$Toast.fail('姓名不能为空')
      }
      if (!this.password) {
        return this.$Toast.fail('密码不能为空')
      }
      if (this.password !== this.newPassword) {
        return this.$Toast.fail('两次输入密码不一致')
      }
      const params = {
        orgId: this.registInfo.orgInfo.id,
        password: this.newPassword,
        phone: this.registInfo.phone,
        userInfoName: this.username,
        verifyId: this.registInfo.verifyId
      }
      this.next2 = false
      this.next3 = true
      this.params = params
      // authSignup(params).then(res => {
      //   if (res.success) {
      //     localStorage.clear()
      //     this.$Toast.success('注册成功')
      //     setTimeout(() => {
      //       this.$router.replace('/login')
      //     }, 1000)
      //   } else {
      //     this.$Toast.fail(res.msg)
      //   }
      // })
    },
    async onSubmit() {
      try {
        if (this.params) {
          const res = await authSignup(this.params)
          if (res.success) {
            localStorage.clear()
            // this.$Toast.success('注册成功')
            setTimeout(() => {
              this.$router.replace('/success?type=3')
            }, 1000)
          } else {
            this.$Toast.fail(res.msg)
          }
        }
      } catch (error) {}
    },
    onReset() {
      this.next2 = false
      this.next3 = false
      this.active1 = false
      this.active2 = false
      this.username = ''
      this.password = ''
      this.newPassword = ''
      this.params = null
    }
  }
}
</script>

<style lang="scss" scoped>
.confirm {
  width: 100%;
  height: 100vh;
  font-size: 14px;
  background-color: #fff;
  .tips {
    width: 100%;
    line-height: 21px;
    padding: 10px 16px;
    box-sizing: border-box;
    background: #fff1d6;
    color: #ffaa00;
  }
  .content {
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    .info-list {
      margin-top: 48px;
      width: 100%;
      height: 135px;
      background: #f8f8f8;
      border-radius: 4px;
      .info-item {
        display: flex;
        align-items: center;
        width: 100%;
        height: 45px;
        padding: 0 16px;
        box-sizing: border-box;
        .name {
          display: flex;
          justify-content: space-between;
          width: 45px;
          font-size: 15px;
          color: #808080;
        }
        .info-detail {
          margin-left: 20px;
          color: #000000;
        }
      }
    }
    .btn {
      margin-top: 44px;
      width: 100%;
      height: 42px;
      font-size: 16px;
      text-align: center;
      line-height: 42px;
      background: #007aff;
      border-radius: 22px;
      color: #fff;
    }
    .tips2 {
      margin-top: 28px;
      text-align: center;
      color: #4d4d4d;
    }
  }
}
.regist-choose-name {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100vh;
  font-size: 14px;
  background: #fff;
  .backgroundImage {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 134px;
    background: linear-gradient(359deg, #ffffff 0%, #ddeafb 100%);
  }
  .avatar {
    margin-top: 134px;
    width: 64px;
    height: 64px;
  }
  .title {
    margin-bottom: 28px;
    margin-top: 134px;
    font-size: 20px;
    font-weight: 500;
    color: #000;
    &.current {
      margin-top: 12px;
    }
  }
  .new-input {
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    width: 304px;
    height: 44px;
    padding: 0 16px;
    box-sizing: border-box;
    border-radius: 44px;
    background-color: #f5f7fa;
    input {
      border: none;
      background: transparent;
      &::placeholder {
        color: #b3b3b3;
        font-size: 14px;
      }
    }
  }
  .submit {
    margin-top: 12px;
    width: 304px;
    height: 44px;
    color: #fff;
    text-align: center;
    line-height: 44px;
    background: rgba(#007aff, 0.35);
    border-radius: 22px;
    &.active {
      background: rgba(#007aff, 1);
    }
  }
}
</style>
